import apiConfig from '@/config/api';

let ws = null;
let heartbeatTimer = null;
let reconnectTimer = null;
let messageQueue = [];
let manualClose = false;

function emitMessage(data) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('admin-ws-message', {
        detail: data
      })
    );
  }
}

function connect() {
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return;
  }

  manualClose = false;
  const wsUrl = apiConfig.getWebSocketUrl();
  ws = new WebSocket(wsUrl);

  ws.onopen = () => {
    startHeartbeat();
    if (messageQueue.length > 0) {
      messageQueue.forEach(msg => ws.send(msg));
      messageQueue = [];
    }
  };

  ws.onmessage = event => {
    if (event.data === 'pong') {
      return;
    }
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'pong') {
        return;
      }
      emitMessage(data);
      if (typeof websocket._handleMessage === 'function') {
        websocket._handleMessage(data);
      }
    } catch (e) {
      // ignore non-json message
    }
  };

  ws.onerror = () => {
    reconnect();
  };

  ws.onclose = () => {
    ws = null;
    if (!manualClose) {
      reconnect();
    }
  };
}

function send(message) {
  const msg = typeof message === 'string' ? message : JSON.stringify(message);
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(msg);
  } else {
    messageQueue.push(msg);
  }
}

function startHeartbeat() {
  clearInterval(heartbeatTimer);
  heartbeatTimer = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send('ping');
    }
  }, 30000);
}

function reconnect() {
  clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(() => {
    connect();
  }, 5000);
}

function close() {
  manualClose = true;
  clearInterval(heartbeatTimer);
  clearTimeout(reconnectTimer);
  if (ws) {
    ws.close();
    ws = null;
  }
}

const websocket = {
  connect,
  send,
  close,
  _handleMessage: null
};

export default websocket;
